/** The Turnstile script in explicit mode: it renders nothing until `turnstile.render` is called. */
export const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let loading: Promise<TurnstileApi> | null = null;

/**
 * Loads the Cloudflare Turnstile script once per page. Only the email-code sign-in calls it, so no
 * other page of the app loads anything from Cloudflare. A failed load can be tried again.
 */
export function loadTurnstileScript(): Promise<TurnstileApi> {
  if (window.turnstile !== undefined) {
    return Promise.resolve(window.turnstile);
  }
  if (loading !== null) {
    return loading;
  }
  loading = new Promise<TurnstileApi>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = TURNSTILE_SCRIPT_URL;
    script.async = true;
    script.onload = () => {
      if (window.turnstile !== undefined) {
        resolve(window.turnstile);
      } else {
        reject(new Error('Turnstile script loaded without the turnstile API'));
      }
    };
    script.onerror = () => {
      script.remove();
      reject(new Error('Turnstile script failed to load'));
    };
    document.head.appendChild(script);
  }).catch((error: unknown) => {
    loading = null;
    throw error;
  });
  return loading;
}

/** Tests only. */
export function resetTurnstileScriptForTests(): void {
  loading = null;
}
